/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBaselineDensityMedium = createReactComponent(
  "baseline-density-medium",
  "IconBaselineDensityMedium",
  [
    ["path", { d: "M4 20h16", key: "svg-0" }],
    ["path", { d: "M4 12h16", key: "svg-1" }],
    ["path", { d: "M4 4h16", key: "svg-2" }]
  ]
);

export { IconBaselineDensityMedium as default };
//# sourceMappingURL=IconBaselineDensityMedium.js.map
